import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	isLoading: false,
	token: '',
	reg: { //正则reg验证
		phoneNum: /^1+\d{10}$/, //手机号验证
		email: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/, //邮箱验证
	},
	foundPhoneNum: {
		phone: '',
		userId: ''
	}
}

const actions = {
	
}

const getters = {
	
}

const mutations = {
	updateLoadingStatus (state, payload) {
    state.isLoading = payload.isLoading
  },
  updateToken (state, newToken) {
  	state.token = newToken
  },
  updatePhoneNum (state, phoneInfo) {
  	state.foundPhoneNum.phone = phoneInfo.phone
  	state.foundPhoneNum.userId = phoneInfo.userId
  },
}

export default new Vuex.Store({
	state,
  actions,
  getters,
  mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js